import React from "react";
import { MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CityTourDetails = () => {
    const tourItems = [
        {
            title: "Lalbagh Botanical Garden",
            description:
                "Start the day at one of Bangalore's most famous gardens, known for its greenery and calm atmosphere.",
            image: "/assets/garden.jpg",
            time: "9:00 AM - 10:30 AM",
        },
        {
            title: "Cubbon Park",
            description:
                "Enjoy a peaceful walk through Cubbon Park in the heart of the city.",
            image: "/assets/park.jpg",
            time: "10:45 AM - 12:00 PM",
        },
        {
            title: "Vidhana Soudha (Outside View)",
            description:
                "Capture photos of Bangalore's most iconic architectural landmark.",
            image: "/assets/OIP.jpg",
            time: "12:15 PM - 1:00 PM",
        },
        {
            title: "Bangalore Palace",
            description:
                "Explore the royal heritage and elegant interiors of Bangalore Palace.",
            image: "/assets/place.jpg",
            time: "1:30 PM - 3:00 PM",
        },
        {
            title: "Commercial Street / MG Road",
            description:
                "End the tour with shopping and street food at Bangalore’s busiest markets.",
            image: "/assets/road.jpg",
            time: "3:15 PM - 5:00 PM",
        },
    ];

    const pickupLocations = ["Marathahalli (Spice Garden)", "Bellandur"];
    const navigate = useNavigate();

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Hero Section */}
            <div className="relative h-72 bg-gradient-to-r from-indigo-600 to-purple-600 flex items-center justify-center">
                <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                    Saturday City Tour <br />
                    <span className="text-lg font-normal">
                        Explore Bangalore in One Day
                    </span>
                </h1>
            </div>

            <div className="max-w-7xl mx-auto px-4 py-12">
                {/* Pickup Locations */}
                <div className="bg-white rounded-2xl shadow-md p-6 mb-14">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                        Pickup Locations
                    </h2>

                    <div className="grid md:grid-cols-2 gap-6">
                        {pickupLocations.map((location, index) => (
                            <div
                                key={index}
                                className="flex items-center gap-4 p-4 border rounded-xl hover:shadow-md transition"
                            >
                                <div className="bg-indigo-600 text-white p-3 rounded-full">
                                    <MapPin size={20} />
                                </div>
                                <p className="text-gray-700 font-medium">
                                    {location}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Tour Stops - Bigger Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
                    {tourItems.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition flex flex-col w-full max-w-sm"
                            style={{ height: "480px" }}
                        >
                            {/* Image */}
                            <div className="h-64 overflow-hidden rounded-t-3xl">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                                />
                            </div>

                            {/* Content */}
                            <div className="p-5 flex flex-col flex-1 justify-between">
                                {/* Title & Time */}
                                <div className="flex items-center justify-between mb-3">
                                    <h2 className="text-lg md:text-xl font-semibold text-gray-800">
                                        {item.title}
                                    </h2>
                                    <p className="text-indigo-600 font-medium">
                                        {item.time}
                                    </p>
                                </div>

                                {/* Description */}
                                <p className="text-gray-600 text-sm md:text-base mb-4 line-clamp-3">
                                    {item.description}
                                </p>

                                {/* Add to Trip Button */}
                                <button className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 rounded-xl font-medium hover:opacity-90 transition mt-auto">
                                    Add to Trip
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom CTA */}
                <div className="text-center mt-16">
                    <button
                        onClick={() => navigate("/booking")}
                        className="bg-purple-600 hover:bg-purple-700 text-white text-lg px-10 py-3 rounded-xl font-semibold"
                    >
                        Book Saturday City Tour
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CityTourDetails;
